<form class="proto-input-form" novalidate
  [formGroup]="editForm"
  [ngClass]="{ 'is-disabled': isLoading }">

  @for (list of formFieldLists; track list.id) {

    <!-- display filter buttons after meta informations -->
    @if (list.id === 'general' && formCategories.length > 1) {
      <div class="form-categories">
        @for (category of formCategories; track category) {
          <ion-button [fill]="selectedCategory === category ? 'solid' : 'outline'" class="proto-button form-category-button"
            (click)="selectedCategory = category">
            {{ ('FORM.CATEGORY.' + category.toUpperCase()) | translate }}
          </ion-button>
        }
      </div>
    }

    @if (selectedCategory === 'all' || !list.category || list.category === selectedCategory) {
      @if (list.type === 'dynamic') {
        @for (item of list.items; track item.id) {
          @let control = asFormArray(item.id);
          <proto-dynamic-form-field
            [field]="item"
            [formArray]="control"
            [values]="dynamicFields[item.id]"></proto-dynamic-form-field>
        }
      } @else {
        @if (list.title) {
          <div class="proto-list-note proto-list-note--inset is-top">{{ list.title | translate }}</div>
        }
        <ion-list class="proto-input-list" inset>
          @for (item of list.items; let i = $index; track item.id) {

            <!-- dynamic fields are already part of dynamic fieldset -->
            @if (item.type !== 'dynamic') {
              @let control = asFormControl(item.id);
              <proto-form-field
                [ngClass]="{'has-badge-buttons': item.type === 'selectModal' && selectedItems[item.id]?.length }"
                [control]="control"
                [field]="item"
                (openModal)="openModal($event)"></proto-form-field>

              @if (item.type === 'selectModal' && selectedItems[item.id]?.length) {
                @if (item.inputType !== 'hidden') {
                  <div class="select-modal-badge-buttons">
                    @for (selectedItem of selectedItems[item.id]; track selectedItem.id) {
                      <ion-button class="select-modal-badge-button" mode="ios" size="small" color="medium-secondary"
                        (click)="removeItemFromSelectModal(item.id, selectedItem.displayName)">
                        {{selectedItem.displayName }} <ion-icon name="close-outline" slot="end"></ion-icon>
                      </ion-button>
                    }
                  </div>
                }
              }
            }
          }
        </ion-list>
      }
    }

  }

  @if (!isEditMode) {
    <ion-list class="proto-input-list" inset>
      <ion-item mode="md" class="ion-activatable form-field-item form-field-item--password is-required">
        <proto-show-hide-password>
          <ion-input class="form-field-item__inner form-field-item__inner--password"
            type="password"
            [tabIndex]="0"
            [formControlName]="passwordFormKey"
            [label]="'FORM.INPUT.PASSWORD.LABEL' | translate"
            [placeholder]="'FORM.INPUT.PASSWORD.LABEL' | translate"/>
        </proto-show-hide-password>
      </ion-item>
    </ion-list>

    <proto-password-validation
      [passwordOptions]="strongPasswordOptions"
      [passwordErrors]="passwordErrors">
    </proto-password-validation>
  }

  <div class="form-footer-buttons">
    <ion-button class="proto-button" fill="outline" color="dark"
      [skipDialog]="!formIsValid()"
      (confirm)="processCompleted.emit('canceled')">
      {{ 'BUTTON.CANCEL' | translate }}
    </ion-button>

    <ion-button class="proto-button submit-button"
      [disabled]="!formIsValid() || isLoading"
      (click)="submit()">
      @if (isEditMode) {
        {{ 'BUTTON.SAVE' | translate }}
      } @else {
        {{ 'BUTTON.CREATE' | translate }}
      }
    </ion-button>
  </div>

</form>
